export const searchCollections = (query: string) => {
  return fetch(`/search/suggest.json?q=${encodeURIComponent(query)}}`)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data?.resources?.results?.collections || [];
    })
    .catch((err) => {
      console.log("Fetch errored or aborted:", err);
      return null;
    });
};
